import React from 'react';

/**
 * Skeleton that mirrors the trending bento layout: one large hero card on
 * the left + two stacked cards on the right, then a row of dense cards.
 * Used in place of the spinner on /trending while data is fetching.
 */
const TrendingGridSkeleton = () => (
  <div className="tg-skel" data-testid="trending-loading">
    <div className="tg-skel-top">
      <div className="tg-skel-hero shimmer" />
      <div className="tg-skel-side">
        <div className="tg-skel-card shimmer" />
        <div className="tg-skel-card shimmer" />
      </div>
    </div>
    <div className="tg-skel-rows">
      {Array.from({ length: 6 }).map((_, i) => (
        <div key={i} className="tg-skel-row">
          <div className="tg-skel-thumb shimmer" />
          <div className="tg-skel-lines">
            <div className="tg-skel-line shimmer" style={{ width: '60%' }} />
            <div className="tg-skel-line shimmer" style={{ width: '35%' }} />
          </div>
        </div>
      ))}
    </div>

    <style jsx>{`
      .tg-skel {
        max-width: 1200px;
        margin: 0 auto;
        padding: 0 1.5rem 3rem;
      }
      .tg-skel-top {
        display: grid;
        grid-template-columns: 1fr;
        gap: 1rem;
        margin-bottom: 1rem;
      }
      @media (min-width: 900px) {
        .tg-skel-top {
          grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
        }
      }
      .tg-skel-hero {
        aspect-ratio: 16 / 11;
        border-radius: 18px;
        min-height: 240px;
      }
      .tg-skel-side {
        display: grid;
        grid-template-rows: 1fr 1fr;
        gap: 1rem;
      }
      .tg-skel-card {
        border-radius: 16px;
        min-height: 110px;
      }
      .tg-skel-rows {
        display: grid;
        grid-template-columns: 1fr;
        gap: 0.85rem;
      }
      @media (min-width: 720px) {
        .tg-skel-rows {
          grid-template-columns: 1fr 1fr;
        }
      }
      .tg-skel-row {
        display: flex;
        gap: 1rem;
        align-items: center;
        background: #111;
        border: 1px solid #1f1f1f;
        border-radius: 12px;
        padding: 0.85rem;
      }
      .tg-skel-thumb {
        width: 64px;
        height: 90px;
        border-radius: 8px;
        flex: 0 0 auto;
      }
      .tg-skel-lines {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
      }
      .tg-skel-line {
        height: 12px;
        border-radius: 6px;
      }
      .shimmer {
        position: relative;
        overflow: hidden;
        background: linear-gradient(135deg, #161616 0%, #0e0e0e 100%);
      }
      .shimmer::after {
        content: '';
        position: absolute;
        inset: 0;
        background: linear-gradient(
          90deg,
          transparent 0%,
          rgba(230, 47, 136, 0.07) 40%,
          rgba(230, 47, 136, 0.14) 50%,
          rgba(230, 47, 136, 0.07) 60%,
          transparent 100%
        );
        transform: translateX(-100%);
        animation: tgshimmer 1.4s ease-in-out infinite;
      }
      @keyframes tgshimmer {
        100% { transform: translateX(100%); }
      }
    `}</style>
  </div>
);

export default TrendingGridSkeleton;
